export function normalizeTimeInput(value) {
  const cleaned = String(value || "").replace(/[^\d:]/g, "").slice(0, 5);
  if (/^\d{3}$/.test(cleaned) || /^\d{4}$/.test(cleaned)) {
    return `${cleaned.slice(0, 2)}:${cleaned.slice(2)}`;
  }
  return cleaned;
}
